import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { AdvancedFiltersContainer } from '../../containers/filters/AdvancedFiltersContainer';
import { IFilter } from '../../types/filters';

export const advancedFilters: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: AdvancedFiltersContainer,
};
